module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/applicant/applicationstatus/applicationstatus.component.css
// module id = ./src/app/applicant/applicationstatus/applicationstatus.component.css
// module chunks = main